<template>
  <div>
    <div>
      1、设置退款审核的投标单位保证金，在发布结果公告后，需招标方先审核同意退款，系统在同意后的5日内自动有息退款至打款账户。
    </div>
    <div>
      2、不需要审核退款的投标单位保证金，在发布结果公告后，系统自动在5日内有息退款至打款账户。
    </div>
    <div>3、流标后所有投标单位保证金当日自动有息退款至打款账户。</div>
    <div>
      4、如果保证金退款状态为已冻结，则需联系项目负责人协商解冻后，才可退回。
    </div>
  </div>
</template>

<script>
export default {
  name: 'BidPurchaseBondRefundCopywriter'
}
</script>

<style lang="scss" scoped></style>
